import { Configuration } from "@azure/msal-browser";

export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.AZURE_CLIENT_ID!,
    authority: `https://login.microsoftonline.com/${process.env.AZURE_TENANT_ID}`,
    redirectUri: typeof window !== "undefined" ? `${window.location.origin}/auth-redirect.html` : "https://localhost:3000/auth-redirect.html",
  },
  cache: {
    // localStorage is shared across windows (same origin), which allows the
    // auth-redirect popup to find the PKCE code_verifier stored by the main window.
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    // Disable telemetry — Outlook's CSP blocks the js.monitor.azure.com scripts
    // that MSAL tries to load, generating CSP violation noise in the console.
    loggerOptions: {
      loggerCallback: () => {},
      piiLoggingEnabled: false,
    },
  },
};

export const crmScopes = [
  `https://${process.env.DYNAMICS_ORG_URL}/.default`,
];

export const graphScopes = [
  "https://graph.microsoft.com/Mail.Read",
  "https://graph.microsoft.com/Calendars.Read",
  "https://graph.microsoft.com/User.Read",
];
